import { Component, OnInit } from '@angular/core';
import { HssResponse} from '../../../services/rest-api/HssResponse';
import { HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import { InfoApiService} from '../../../services/rest-api/info.api.service';
import {ActivatedRoute, Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import {StorageService} from '../../../services/rest-api/storage.service';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-research',
  templateUrl: './research.component.html',
  styleUrls: ['./research.component.scss']
})
export class ResearchComponent implements OnInit {

  pubCountData: any[] = [];
  publicationData: any[] = [];
  pubForm!: FormGroup;
  areaList: any[] = [];
  public pubAreaId: number = 0;
  myDate = new Date();
  staffData: [] | any;
  publicationArea: string = "";

  // loaders
  citeLoader: boolean = false;
  citeRepat: any[] = [1,2,3,4,5,6,7,8,9,10];

  constructor(private _info: InfoApiService,
              private _formBuilder: FormBuilder,
              private _actRoute: ActivatedRoute,
              private router: Router,
              public storage: StorageService,
              private seo: SeoService) {

    this._actRoute.paramMap.subscribe(params => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {

    this.seo.setMeta('Publications of the Faculty of Humanities & Social Sciences')

    this.pubAreaId = this._actRoute.snapshot.params.id;
    this.getPublicationsByArea(this.pubAreaId);

    this.getPublicationCount();
    this.getPubAreaList();

    const test = this.storage.getData('staffData');
    this.staffData = test ? JSON.parse(test): [];
    // this.getMemberName();
  }

  // Get Publications by area
  getPublicationsByArea(areaId: number){
    this.citeLoader = true;
    this._info.getPubByArea(areaId).subscribe (
      (response: HssResponse<any>) => {
        this.publicationData = response.body;

        // Array merge from front side with from the local storage
        // const pubData = response.body;
        // const staffArray : object[] = this.staffData;
        // this.publicationData = pubData.map((publication:any) => ({...publication, ...staffArray.find((staff:any) => staff.id === publication.staff_id)}));

        this.citeLoader = false;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get publication statistics
  getPublicationCount(){
    this._info.getPubCount().subscribe (
      (response: HssResponse<any>) => {
        this.pubCountData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // get publications areas
  getPubAreaList(){
    this._info.getPublicationAreas().subscribe (
      (response: HssResponse<any>) => {
        // Populate model
        this.areaList = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  getMemberName(){
    const test = this.storage.getData('staffData');
    let staffData = test ? JSON.parse(test): [];
  }

  showPubArea(area: any, pub: any){
    this.publicationArea = area+" ("+ pub +")";
  }

}
